/**
 * Extrai a primeira URL de imagem de diferentes formatos:
 * - String JSON array: '["url1","url2"]' -> retorna "url1"
 * - Array de strings: ["url1", "url2"] -> retorna "url1"
 * - String simples: "url" -> retorna "url"
 * 
 * @param imageValue - Valor que pode ser uma URL, array de URLs ou JSON string de array
 * @returns A primeira URL válida ou null se não encontrar
 */
export function parseFirstImageUrl(imageValue: unknown): string | null {
    if (!imageValue) return null;

    // Se já for um array
    if (Array.isArray(imageValue)) {
        const firstUrl = imageValue.find(url => typeof url === 'string' && url.trim());
        return firstUrl || null;
    }

    // Se for uma string
    if (typeof imageValue === 'string') {
        const trimmed = imageValue.trim();

        // Tenta fazer parse como JSON array
        if (trimmed.startsWith('[')) {
            try {
                const parsed = JSON.parse(trimmed);
                if (Array.isArray(parsed)) {
                    const firstUrl = parsed.find((url: unknown) => typeof url === 'string' && (url as string).trim());
                    return firstUrl || null;
                }
            } catch {
                // Se falhar o parse, trata como URL única
            }
        }

        // URL única
        return trimmed || null;
    }

    return null;
}
